import ApiResourceManager from '../ApiResourceManager';

export default class CurrentCompanyInfoManager extends ApiResourceManager {
  get = async (params) =>
    this.request({
      method: 'GET',
      url: '/current-company/company-info',
      params,
    });

  update = (data) =>
    this.request({
      method: 'PUT',
      url: '/current-company/company-info',
      data,
    });
}
